import { render, staticRenderFns } from "./FormDialUpSetHowen.vue?vue&type=template&id=369a20c8&scoped=true&"
import script from "./FormDialUpSetHowen.vue?vue&type=script&lang=ts&"
export * from "./FormDialUpSetHowen.vue?vue&type=script&lang=ts&"
import style0 from "./FormDialUpSetHowen.vue?vue&type=style&index=0&id=369a20c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a20c8",
  null
  
)

export default component.exports